// One type scale and one set of states for every field in the portal, so a
// form reads at the same size as the tables and panels around it rather than
// a step larger.
export const FIELD_LABEL =
  "mb-1.5 block text-xs font-medium text-gray-600";

export const FIELD_ERROR = "mt-1 text-[11px] text-danger-600";

export const FIELD_BASE =
  "block w-full rounded-lg border bg-white px-3 py-2 text-[13px] outline-none transition-colors placeholder:text-gray-400";

export const fieldState = (hasError) =>
  hasError
    ? "border-danger-300 hover:border-danger-400 focus:border-danger-500 focus:ring-2 focus:ring-danger-100"
    : "border-gray-200 hover:border-gray-300 focus:border-brand-500 focus:ring-2 focus:ring-brand-100";

export const FIELD_DISABLED =
  "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400";
